<template>
	<div>
		<app-header></app-header>
		<div class="row page-header">
			<div class="container">
				<div class="row">
					<div class="col-sm-1">
						<img src="../../assets/images/temporary/freelacer-profile-picture.png">
					</div>

					<div class="col-sm-9">
						<h1 class="page-title">Ivan Abadzhiev</h1>
						<p><i class="fas fa-map-marker-alt"></i> Sofia, Bulgaria</p>
					</div>

					<div class="col-sm-2">
						<button class="btn btn-success">Invite to Work</button>
					</div>
				</div>
			</div>
		</div>
		<div class="container">
		

			<div class="row">
				<div class="col-sm-12">
					<img src="../../assets/images/cover-photo.png">
				</div>
			</div>

			<div class="row">&nbsp;</div>

			<div class="row">
				<div class="col-sm-12">
					<ul class="nav nav-tabs" id="myTab" role="tablist">
					  <li class="nav-item">
					    <a class="nav-link active" id="about-me-tab" data-toggle="tab" href="#about-me" role="tab" aria-controls="about" aria-selected="true">About</a>
					  </li>
					  <li class="nav-item">
					    <a class="nav-link" id="portfolio-tab" data-toggle="tab" href="#portfolio" role="tab" aria-controls="portfolio" aria-selected="false">Portfolio</a>
					  </li> 
					</ul>
				</div>
			</div>

			<div class="tab-content">
			  <div class="tab-pane active" id="about-me" role="tabpanel" aria-labelledby="about-me-tab">
			  	<div class="row">
				  	<div class="col-sm-8">
				  		<!-- Section for freelancer description -->
				  		<div class="row">&nbsp;</div>
				  		<div class="row">
				  			<h4>Main Infromation</h4>
				  			<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
				  			tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
				  			quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
				  			consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
				  			cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
				  			proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

				  			<small>Member since: April 09,2013</small>
				  		</div>

				  		<hr>

				  		<div class="row">
				  			<h4>Work history and feedback</h4>
				  		</div>

				  		<div class="row feedback-box" v-for="n in 3">
				  			<div class="col-sm-3">
				  				<img src="../../assets/images/project-mia.png">
				  			</div>

				  			<div class="col-sm-9">
				  				<div class="row">
				  					<el-rate
									  v-model="rate1"
									  disabled
									  :texts="['1','2','3','3.7','4','5']"
									  show-text
									  text-color="#ff9900"
									  text-template="{value} points">
									</el-rate>

									<span>&nbsp;Oct 2017 - Jan 2018</span>
				  				</div>	

				  				<div class="row">
				  					<p class="feedback-description">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
				  					tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
				  				</div>

				  				<div class="row">
				  					<strong>Jason Statement</strong>
				  				</div>
				  			</div>
				  		</div>
				  		<div class="row">&nbsp;</div>
				  		<div class="row">&nbsp;</div>
				  		<div class="row">&nbsp;</div>
				  	</div>
				  	<div class="col-sm-4">
				  		<!-- Experience Box -->
						<div class="box">
							<h4>Experience</h4>

							<div class="row">
								<div class="col-sm-6">
									<div class="number">43</div> 
									<span>Jobs</span>
								</div>

								<div class="col-sm-6">
									<div class="number">205</div> 
									<span>1-to-1 Projects</span>
								</div>

								<div class="col-sm-6">
									<div class="number">$10+</div> 
									<span>Total earned</span>
								</div>

								<div class="col-sm-6">
									<div class="number">32</div> 
									<span>Repeat clients</span>
								</div>
							</div>
						</div>

						<!-- Skills Box -->
						<div class="box">
							<h4>Skills</h4>

							<div class="row">
								<span class="btn-skills">Product label</span>
								<span class="btn-skills">Illustration</span>
								<span class="btn-skills">Drawing</span>
								<span class="btn-skills">Digital painting</span>
							</div>
						</div>

						<!-- Languages Box -->
						<div class="box">
							<h4>Languages</h4>
							<p>Bulgarian, English, Spanish</p>
						</div>
				  	</div>	
			  	</div>
			  </div>
			  <div class="tab-pane" id="portfolio" role="tabpanel" aria-labelledby="portfolio-tab">Portfolio</div>
			</div>
		</div>
		<footer-actions></footer-actions>
		<app-footer></app-footer>
	</div>
</template>

<script type="text/javascript">
import Header from '../Header.vue';
import Footer from '../Footer.vue';
import FooterActions from '../FooterActions.vue';
import jquery from 'jquery';
import 'bootstrap'

export default {
	data() {
		return {
			rate1 : 3.7
		}
	},
	methods : {

	},
	components : {
		appHeader : Header,
		footerActions : FooterActions,
		appFooter : Footer
	},
	beforeMount() {
		//tabs
		let $ = jquery;

		$('#myTab a').on('click', function (e) {
			console.log('click tab')
		  e.preventDefault()
		  $(this).tab('show')

		})
	}
}
</script>

<style type="text/css">
@import '../../assets/css/stylesheet.css';

.btn .btn-success {
	background-color: #38DCAB;
}

img {
	width: 100%;
}

.box {
	background-color: rgb(244, 244, 244);
	margin-top: 2em;
	padding: 1.5em;
}

.number {
	color: rgb(55, 201, 159);
	font-size: 2em;
}

.btn-skills {
	background-color: #fff;
    border: 1px solid #fff;
    border-radius: 2px;
    margin-right: 0.2em;
    margin-bottom: 0.3em;
    padding: 0.2em;
}

hr {
	border: 0;
    border-top: 1px solid rgba(0,0,0,.1);
}

.feedback-box {
	margin-top:2em;
}

.feedback-description {
	font-style: italic;
}

</style>


// WEBPACK FOOTER //
// src/components/freelancer/FreelancerDetail.vue